<template>
    <tr class="entity-row-cs-36" v-if="!isDeleted">
        <td>

            <router-link :to="{ name: 'door-check-view-door', params: {id: door_check_door.site_door_check_door_id} }" class="d-block">
                {{ door_check_door.door_id }} | {{ door_check_door.barcode }} </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'door-check-view-door', params: {id: door_check_door.site_door_check_door_id} }" class="a-primary d-block">
                View </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'door-check-edit-door', params: {id: door_check_door.site_door_check_door_id} }"  class="a-info d-block">Edit</router-link>
        </td>
        <td>
            <a class="a-positive d-block"
               v-bind:href="'#clone-door-link-' + door_check_door.door_check_door_id"
               v-bind:id="'clone-door-link-' + door_check_door.door_check_door_id"
               v-on:click="cloneDoor"
               v-bind:data-door-check-door-id="door_check_door.door_check_door_id"
               ref="cloneButton"
            >
                Clone Door</a>
        </td>
        <td>
            <a class="a-danger delete-entity d-block"
               v-bind:href="'#delete-door-link-' + door_check_door.site_door_check_door_id"
               v-bind:id="'delete-door-link-' + door_check_door.site_door_check_door_id"
               v-on:click="deleteDoor"
               v-bind:data-door-check-door-id="door_check_door.site_door_check_door_id"
               ref="deleteButton"
            >Delete</a>
        </td>
    </tr>
</template>
<script>
    export default {
        props: ['door_check_door'],
        data() {
            return {
                isDeleted: false,
                doorCheckDoorToDelete: null,
                doorCheckDoorToClone: null,
            }
        },
        methods: {
            deleteDoor() {
                var button = this.$refs.deleteButton;
                var reportId = button.dataset.doorCheckDoorId;

                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var doorCheckDoorId = parseInt(reportId);
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        var storeRequest = objectStore.get(doorCheckDoorId);

                        storeRequest.onsuccess = function(event) {
                            vm.doorCheckDoorToDelete = storeRequest.result;
                            vm.doorCheckDoorToDelete.is_deleted = true;

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to delete this door?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    var putRequest = db.transaction('door_check_doors', 'readwrite')
                                        .objectStore('door_check_doors').put(vm.doorCheckDoorToDelete);
                                    putRequest.onsuccess = function(event) {
                                        vm.isDeleted = true;
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            });
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch(e) {
                        console.log(e);
                    }
                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };
            },
            cloneDoor() {
                var button = this.$refs.deleteButton;
                var reportId = button.dataset.doorCheckDoorId;

                this.$swal({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to clone this door?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true,
                    buttons: {
                        cancel: {
                            text: 'Cancel',
                            value: null,
                            visible: false,
                            className: 'btn btn-square btn-sm btn-secondary',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Yes',
                            value: true,
                            visible: true,
                            className: 'btn btn-square btn-sm btn-primary',
                            closeModal: true
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                        this.getDbNew().then(db => {
                            var doorCheckDoorId = parseInt(reportId);
                            var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                            var storeRequest = objectStore.get(doorCheckDoorId);
                            var vm = this;

                            storeRequest.onsuccess = function(event) {
                                vm.doorCheckDoorToClone = storeRequest.result;
                                vm.doorCheckDoorToClone.barcode = storeRequest.result.barcode + ' ( clone )';
                                vm.doorCheckDoorToClone.door_check_door_images = [];
                                vm.doorCheckDoorToClone.offline_images = [];
                                vm.doorCheckDoorToClone.site_door_check_door_id = Math.floor(new Date().getTime() / 1000);

                                if(vm.doorCheckDoorToClone.pin_number != undefined && vm.doorCheckDoorToClone.pin_number != null) {
                                    try {
                                        var highestMarkerNumber = null;
                                        objectStore.openCursor().onsuccess = function (event) {
                                            var cursor = event.target.result;

                                            if (cursor) {
                                                if(
                                                    cursor.value.site_door_check_id == vm.doorCheckDoorToClone.site_door_check_id && 
                                                    (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined) &&
                                                    cursor.value.pin_number &&
                                                    (!highestMarkerNumber || highestMarkerNumber < cursor.value.pin_number)
                                                ) {
                                                    highestMarkerNumber = cursor.value.pin_number;
                                                }
                                                cursor.continue();
                                            } else {
                                                vm.doorCheckDoorToClone.pin_number = highestMarkerNumber + 1;
                                                var putRequest = db.transaction('door_check_doors', 'readwrite')
                                                    .objectStore('door_check_doors').put(vm.doorCheckDoorToClone);
                                                putRequest.onsuccess = function(event) {
                                                    vm.reload();
                                                };
                                                putRequest.onerror = function(event) {
                                                    console.log(event);
                                                };
                                            }
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                } else {
                                    var putRequest = db.transaction('door_check_doors', 'readwrite')
                                        .objectStore('door_check_doors').put(vm.doorCheckDoorToClone);
                                    putRequest.onsuccess = function(event) {
                                        vm.reload();
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            };
                            storeRequest.onerror = function(e) {
                                console.log(e)
                            }
                        });
                        
                    }
                });
            },
            reload() {
                window.location = '';
            }
        }
    }
</script>